
(() => {
  'use strict';

  function init(scope = document) {
    const sections = [];

    if (scope.matches?.('[data-cspp]')) {
      sections.push(scope);
    }

    scope.querySelectorAll?.('[data-cspp]').forEach(section => {
      sections.push(section);
    });

    sections.forEach(section => {
      if (section.dataset.csppInit === '1') return;
      section.dataset.csppInit = '1';

      const slides = Array.from(
        section.querySelectorAll('[data-cspp-media]')
      );

      const thumbs = Array.from(
        section.querySelectorAll('[data-cspp-thumb]')
      );

      const track = section.querySelector('.CSPP__thumbs');
      const form = section.querySelector('form[action*="/cart/add"]');
      const variantInput =
        form?.querySelector('[name="id"]') ||
        section.querySelector('[data-cspp-variant-id]');

      const errorBox = section.querySelector('[data-cspp-error]');
      const picker = section.querySelector('variant-selects');

      let variants = [];
      let visible = slides.map(slide =>
        String(slide.dataset.csppMedia)
      );
      let active = '';
      let pendingFrame = null;

      try {
        variants = JSON.parse(
          section.querySelector('[data-cspp-variants]')?.textContent || '[]'
        );
      } catch (error) {
        console.error('CSPP: Unable to read variants', error);
      }

      const money = cents =>
        new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'INR',
          maximumFractionDigits: 2
        }).format((Number(cents) || 0) / 100);

      function currentVariant() {
        const id = variantInput?.value;

        return variants.find(
          variant => String(variant.id) === String(id)
        );
      }

      function showError(message) {
        if (errorBox) errorBox.textContent = message || '';
      }

      /* -----------------------------
         THUMBNAIL ARROWS
      ----------------------------- */

      function updateThumbArrows() {
        if (!track) return;

        const max = track.scrollWidth - track.clientWidth;
        const prev = section.querySelector('[data-cspp-thumb-prev]');
        const next = section.querySelector('[data-cspp-thumb-next]');

        if (prev) prev.disabled = track.scrollLeft <= 2;

        if (next) {
          next.disabled =
            max <= 2 || track.scrollLeft >= max - 2;
        }
      }

      function scrollThumbs(direction) {
        if (!track) return;

        const thumb = track.querySelector(
          '.CSPP__thumb:not([hidden])'
        );

        const step =
          (thumb?.getBoundingClientRect().width || 120) + 10;

        track.scrollBy({
          left: step * 2 * direction,
          behavior: 'smooth'
        });
      }

      section.querySelector('[data-cspp-thumb-prev]')
        ?.addEventListener('click', () => scrollThumbs(-1));

      section.querySelector('[data-cspp-thumb-next]')
        ?.addEventListener('click', () => scrollThumbs(1));

      track?.addEventListener('scroll', updateThumbArrows, {
        passive: true
      });

      /* -----------------------------
         GALLERY IMAGE DISPLAY
      ----------------------------- */

      function showImage(id) {
        id = String(id || '');

        if (!visible.includes(id)) return;

        active = id;

        slides.forEach(slide => {
          const isActive =
            String(slide.dataset.csppMedia) === id;

          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
        });

        thumbs.forEach(thumb => {
          const thumbId = String(thumb.dataset.csppThumb);
          const isVisible = visible.includes(thumbId);
          const isActive = thumbId === id;

          thumb.hidden = !isVisible;
          thumb.classList.toggle('is-active', isActive);

          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });

        const activeThumb = thumbs.find(
          thumb => String(thumb.dataset.csppThumb) === id
        );

        if (activeThumb && track) {
          const left = activeThumb.offsetLeft;
          const right = left + activeThumb.offsetWidth;

          if (left < track.scrollLeft) {
            track.scrollTo({
              left,
              behavior: 'smooth'
            });
          } else if (
            right > track.scrollLeft + track.clientWidth
          ) {
            track.scrollTo({
              left: right - track.clientWidth,
              behavior: 'smooth'
            });
          }
        }

        updateThumbArrows();
      }

      /* -----------------------------
         VARIANT IMAGE FILTER
      ----------------------------- */

      function updateGallery(variant) {
        const ids = slides.map(slide =>
          String(slide.dataset.csppMedia)
        );

        if (!ids.length) return;

        const featuredId = String(
          variant?.featured_media?.id || ''
        );

        const featuredIndex = ids.indexOf(featuredId);

        const groupStarts = slides
          .map((slide, index) =>
            slide.dataset.csppStart === 'true' ? index : -1
          )
          .filter(index => index >= 0);

        /*
         * If the selected variant has no featured image,
         * don't accidentally hide every image.
         */
        if (featuredIndex < 0) {
          visible = ids;
          showImage(ids[0]);
          return;
        }

        /*
         * If Liquid doesn't mark separate image groups,
         * keep the standard gallery working.
         */
        if (groupStarts.length < 2) {
          visible = ids;
          showImage(featuredId);
          return;
        }

        /*
         * Find the nearest group start at or before the
         * selected variant's featured image.
         */
        const groupStart = groupStarts
          .filter(index => index <= featuredIndex)
          .pop();

        if (groupStart === undefined) {
          visible = ids;
          showImage(featuredId);
          return;
        }

        const nextGroupStart = groupStarts.find(
          index => index > groupStart
        );

        const groupEnd =
          nextGroupStart === undefined
            ? ids.length
            : nextGroupStart;

        /*
         * Only this group can be used by arrows,
         * thumbnails and mobile swipe.
         */
        visible = ids.slice(groupStart, groupEnd);

        showImage(
          visible.includes(featuredId)
            ? featuredId
            : visible[0]
        );
      }

      /* -----------------------------
         VARIANT DETAILS
      ----------------------------- */

      function updateVariant(variant) {
        if (!variant) return;

        if (variantInput) {
          variantInput.value = String(variant.id);
          variantInput.disabled = false;
        }

        const price = section.querySelector('[data-cspp-price]');
        const compare = section.querySelector('[data-cspp-compare]');
        const discount = section.querySelector('[data-cspp-discount]');
        const sku = section.querySelector('[data-cspp-sku]');
        const add = section.querySelector('[data-cspp-add]');
        const buy = section.querySelector('[data-cspp-buy-now]');
        const label = section.querySelector('[data-cspp-add-label]');

        if (price) {
          price.textContent = money(variant.price);
        }

        const comparePrice = Number(variant.compare_at_price || 0);
        const currentPrice = Number(variant.price || 0);
        const onSale = comparePrice > currentPrice;

        if (compare) {
          compare.hidden = !onSale;
          compare.textContent = onSale ? money(comparePrice) : '';
        }

        if (discount) {
          discount.hidden = !onSale;
          discount.textContent = onSale
            ? Math.round(
                ((comparePrice - currentPrice) / comparePrice) * 100
              ) + '% OFF'
            : '';
        }

        if (sku) {
          sku.textContent = variant.sku || '—';
        }

        if (add) add.disabled = !variant.available;
        if (buy) buy.disabled = !variant.available;

        if (label) {
          label.textContent = variant.available
            ? (label.dataset.availableText || 'Add To Cart')
            : 'Sold Out';
        }

        updateGallery(variant);
        showError('');
      }

      /* -----------------------------
         VARIANT PICKER
      ----------------------------- */

      function getSelectedVariant() {
        if (!picker) return currentVariant();

        const values = [];

        picker.querySelectorAll(
          'fieldset, .product-form__input--dropdown'
        ).forEach(group => {
          const radio = group.querySelector(
            'input[type="radio"]:checked'
          );

          const select = group.querySelector('select');

          if (radio) {
            values.push(radio.value);
          } else if (select) {
            values.push(select.value);
          }
        });

        if (!values.length) return currentVariant();

        return variants.find(variant =>
          Array.isArray(variant.options) &&
          variant.options.length === values.length &&
          variant.options.every(
            (value, index) => value === values[index]
          )
        ) || null;
      }

      function onPickerChange() {
        if (pendingFrame) {
          cancelAnimationFrame(pendingFrame);
        }

        pendingFrame = requestAnimationFrame(() => {
          pendingFrame = null;

          const variant = getSelectedVariant();

          if (variant) {
            updateVariant(variant);
          }
        });
      }

      picker?.addEventListener('change', onPickerChange);

      picker?.addEventListener('variant:change', event => {
        if (event.detail?.variant) {
          updateVariant(event.detail.variant);
        }
      });

      /* -----------------------------
         MAIN GALLERY ARROWS
      ----------------------------- */

      function moveImage(direction) {
        if (!visible.length) return;

        let index = visible.indexOf(active);
        if (index < 0) index = 0;

        const nextIndex =
          (index + direction + visible.length) % visible.length;

        showImage(visible[nextIndex]);
      }

      section.querySelector('[data-cspp-prev]')
        ?.addEventListener('click', () => moveImage(-1));

      section.querySelector('[data-cspp-next]')
        ?.addEventListener('click', () => moveImage(1));

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          showImage(thumb.dataset.csppThumb);
        });
      });

      /* -----------------------------
         MOBILE SWIPE
      ----------------------------- */

      const hero = section.querySelector('.CSPP__hero');

      if (hero) {
        let startX = 0;
        let startY = 0;

        hero.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) return;

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });

        hero.addEventListener('touchend', event => {
          if (!event.changedTouches.length) return;

          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - startX;
          const deltaY = touch.clientY - startY;

          if (
            Math.abs(deltaX) < 45 ||
            Math.abs(deltaX) < Math.abs(deltaY) * 1.2
          ) {
            return;
          }

          moveImage(deltaX < 0 ? 1 : -1);
        }, { passive: true });
      }

      /* -----------------------------
         IMAGE ZOOM
      ----------------------------- */

      section.querySelector('[data-cspp-zoom]')
        ?.addEventListener('click', () => {
          const activeSlide = slides.find(
            slide =>
              String(slide.dataset.csppMedia) === active
          );

          const image = activeSlide?.querySelector('img');
          if (!image) return;

          const lightbox = document.createElement('div');
          lightbox.className = 'CSPP__lightbox';

          const close = document.createElement('button');
          close.type = 'button';
          close.setAttribute('aria-label', 'Close');
          close.textContent = '×';

          const copy = image.cloneNode();
          copy.removeAttribute('srcset');

          lightbox.append(close, copy);
          document.body.append(lightbox);

          function closeLightbox() {
            lightbox.remove();
            document.removeEventListener('keydown', onKeydown);
          }

          function onKeydown(event) {
            if (event.key === 'Escape') closeLightbox();
          }

          close.addEventListener('click', closeLightbox);

          lightbox.addEventListener('click', event => {
            if (event.target === lightbox) closeLightbox();
          });

          document.addEventListener('keydown', onKeydown);
        });

      /* -----------------------------
         QUANTITY CONTROLS
      ----------------------------- */

      section.querySelector('[data-cspp-qty-minus]')
        ?.addEventListener('click', () => {
          const input = form?.querySelector('[name="quantity"]');

          if (input) {
            input.value = Math.max(
              1,
              (parseInt(input.value, 10) || 1) - 1
            );

            input.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          }
        });

      section.querySelector('[data-cspp-qty-plus]')
        ?.addEventListener('click', () => {
          const input = form?.querySelector('[name="quantity"]');

          if (input) {
            input.value =
              Math.max(1, parseInt(input.value, 10) || 1) + 1;

            input.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          }
        });

      /* -----------------------------
         BUY NOW
      ----------------------------- */

      section.querySelector('[data-cspp-buy-now]')
        ?.addEventListener('click', async () => {
          const variant = currentVariant();

          const quantity = Math.max(
            1,
            parseInt(
              form?.querySelector('[name="quantity"]')?.value,
              10
            ) || 1
          );

          const buy = section.querySelector('[data-cspp-buy-now]');

          if (!variant || !variant.available) {
            showError('Please select an available variant.');
            return;
          }

          if (buy) buy.disabled = true;
          showError('');

          try {
            const rootUrl = window.Shopify?.routes?.root || '/';

            const response = await fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                items: [{ id: variant.id, quantity }]
              })
            });

            const data = await response.json();

            if (!response.ok) {
              throw new Error(
                data.description ||
                data.message ||
                'Unable to add this item to cart.'
              );
            }

            window.location.href = rootUrl + 'checkout';
          } catch (error) {
            showError(error.message);

            if (buy) buy.disabled = false;
          }
        });

      /* -----------------------------
         DELIVERY / PINCODE CHECKER
      ----------------------------- */

      section.querySelectorAll('[data-cspp-delivery]')
        .forEach(initDeliveryChecker);

      function initDeliveryChecker(checker) {
        if (checker.dataset.pinInitialized === 'true') return;
        checker.dataset.pinInitialized = 'true';

        const pinForm = checker.querySelector('[data-cspp-pin-form]');
        const input = checker.querySelector('[data-cspp-pincode]');
        const result = checker.querySelector('[data-cspp-pin-result]');

        if (!pinForm || !input || !result) return;

        function showResult(message, type, estimateText) {
          result.replaceChildren();
          result.className = `CSPP__delivery-result is-${type}`;

          const status = document.createElement('div');
          status.textContent = message;
          result.appendChild(status);

          if (estimateText) {
            const estimate = document.createElement('span');
            estimate.className = 'CSPP__delivery-estimate';
            estimate.textContent = estimateText;
            result.appendChild(estimate);
          }

          result.hidden = false;
        }

        /*
         * DELIVERY DATE CALCULATOR
         * Start date: current date + 7 calendar days.
         * End date: current date + 14 calendar days.
         * Day name and date are displayed for both dates.
         */
        function getDeliveryEstimate() {
          const today = new Date();

          // Use local calendar dates, without the current time.
          const startDate = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate()
          );

          const endDate = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate()
          );

          startDate.setDate(startDate.getDate() + 7);
          endDate.setDate(endDate.getDate() + 14);

          const dateFormatter = new Intl.DateTimeFormat('en-IN', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          });

          return 'Estimated Delivery: ' +
            dateFormatter.format(startDate) +
            ' – ' +
            dateFormatter.format(endDate);
        }

        pinForm.addEventListener('submit', event => {
          event.preventDefault();

          const pincode = input.value.trim();

          if (!/^\d{6}$/.test(pincode)) {
            input.setAttribute('aria-invalid', 'true');

            showResult(
              'Please enter a valid 6-digit pincode.',
              'error'
            );

            return;
          }

          input.removeAttribute('aria-invalid');

          const cityMap = (checker.dataset.cityMapping || '')
            .split(',')
            .map(entry => entry.trim())
            .filter(Boolean)
            .reduce((map, entry) => {
              const separator = entry.indexOf(':');

              if (separator > -1) {
                map[entry.slice(0, separator).trim()] =
                  entry.slice(separator + 1).trim();
              }

              return map;
            }, {});

          const city = cityMap[pincode];

          showResult(
            '✓ Pincode accepted' +
              (city ? ': ' + city : '') +
              ' (' + pincode + ')',
            'success',
            getDeliveryEstimate()
          );
        });

        input.addEventListener('input', () => {
          input.value = input.value.replace(/\D/g, '').slice(0, 6);
          input.removeAttribute('aria-invalid');
          result.hidden = true;
        });
      }

      /* -----------------------------
         INITIAL VARIANT
      ----------------------------- */

      const initial = currentVariant();

      if (initial) {
        updateVariant(initial);
      } else if (slides.length) {
        visible = slides.map(slide =>
          String(slide.dataset.csppMedia)
        );

        const initiallyVisible = slides.find(slide => !slide.hidden);

        showImage(
          initiallyVisible?.dataset.csppMedia || visible[0]
        );
      }

      updateThumbArrows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });
})();
